<template>
  <main class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">发货单号：{{out_bill_no}}</span>
      <button @click="back" class="ivu-btn ml50 fr">返回</button>
    </div>
    <div class="infn-box">
      <p><span>创建日期</span>：{{detail.create_date||'-'}}</p>
      <p><span>客户编号</span>：{{detail.client_code||'-'}}</p>
      <p class="h1"><span>总重量</span>：{{detail.weight + 'lbs'||'-'}}</p>
      <p><span>所属公司</span>：{{detail.client_code_name||'-'}}</p>
      <p><span>客户名称</span>：{{detail.client_name||'-'}}</p>
      <p class="h1"><span>总件数</span>：{{detail.packages + '件'||'-'}}</p>
      <div class="bg-yellow">
        <p class="h2"><span>状态</span>：{{stauts[detail.status] ||'-'}}</p>
        <p><span>主单号</span>：{{detail.main_bill_no||'-'}}</p>
        <p><span>航班号</span>：{{detail.flight_no||'-'}}</p>
        <p><span>发货日期</span>：{{detail.send_out_date||'-'}}</p>
      </div>
    </div>
    <div class="mt40">
      <Table border :columns="columns" :data="detail_list"></Table>
    </div>

    <!-- 发货 -->
    <Modal v-model="show_send" title="确认发货" width="500" footer-hide>
      <div>
        <div class="p20">
          <div>
            主单号：<Input v-model="form_data.main_bill_no" class="w200" placeholder="请输入主单号"></Input>
          </div>
          <div class="mt20">
            航班号：<Input v-model="form_data.flight_no" class="w200" placeholder="请输入航班号"></Input>
          </div>
        </div>
        <div class="tc mt20">
          <button class="ivu-btn mr10" @click="show_send=false">取消</button>
          <button class="ivu-btn ivu-btn-primary" @click="confirm">确定</button>
        </div>
      </div>
    </Modal>

    <!-- 声音组件 -->
    <Voice ref="child"></Voice>
    <VoiceText ref="voiceText"></VoiceText>
  </main>
</template>
<script>
  import Voice from "@/components/common/voice";
  import VoiceText from "@/components/common/voice.text";
  export default {
    components: {
      Voice,
      VoiceText
    },
    data() {
      return {
        waybill_code: '',
        out_bill_no: '',
        stauts: { //0-待发货， 10-已发货， -10已取消
          0: '待发货',
          10: '已发货',
          '-10': '已取消',
        },
        detail: {},
        detail_list: [],
        columns: [{
          title: '快递机构',
          key: 'waybill_name',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '快递单号',
          key: 'waybill_code',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '运单号',
          key: 'in_bill_no',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '重量(lbs)',
          key: 'weight',
          tooltip: true,
          minWidth: 120,
        }, {
          title: '初次扫描时间',
          key: 'create_date',
          tooltip: true,
          width: 200,
        }],
        show_send: false, //发货弹框
        form_data: {},
        error_msg: '',
      }
    },
    methods: {
      back() {
        this.$router.back(-1)
      },
      openSend() { //打开发货
        this.form_data = {}
        this.show_send = true
      },
      getDetail() {
        this.$axios.get("/fh/out/bill/detail", {
          params: {
            out_bill_no: this.out_bill_no
          }
        }).then(res => {
          if (res.success && res.data) {
            this.detail = res.data;
          }
        })
      },
      inputEnter() { //回车事件
        this.append()
      },
      append() { //装入或取出包裹
        this.error_msg = '';
        this.$refs.waybillcode.select()
        this.$refs.waybillcode.focus()
        if (this.detail.status == 10) { //已发货
          return;
        }
        if (!this.waybill_code) {
          this.$Message.info('请扫码单号')
          return;
        }
        this.$axios.post("/fh/out/bill/detail/append", this.$qs.stringify({
          out_bill_no: this.out_bill_no,
          waybill_code: this.waybill_code,
        })).then(res => {
          if (res.success && res.data) {
            this.$refs.voiceText.voicePlay(res.data)
            this.init()
          } else {
            this.error_msg = res.msg
          }
        })
      },
      getDetlist() { //获取发货单包裹列表
        this.$axios.get("/fh/out/bill/detail/list", {
          params: {
            out_bill_no: this.out_bill_no
          }
        }).then(res => {
          if (res.success && res.data) {
            this.detail_list = res.data;
          }
        })
      },
      confirm() { //确认发货
        if (!this.form_data.main_bill_no) {
          this.$Message.info('请录入主单号')
          return
        }
        if (!this.form_data.flight_no) {
          this.$Message.info('请录入航班号')
          return
        }
        this.$axios.post("/fh/out/bill/confirm", this.$qs.stringify({
          ...this.form_data,
          out_bill_no: this.out_bill_no,
        })).then(res => {
          if (res.success) {
            this.$Message.success('确认成功')
            this.show_send = false;
            this.init()
          }
        })
      },
      cancel() { //取消
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p> 您正在取消发货批次' + this.out_bill_no + '，确认要进行此操作吗？</p>',
          onOk: () => {
            this.$axios.post("/fh/out/bill/cancel?out_bill_no=" + this.out_bill_no)
              .then(res => {
                if (res.success && res.data) {
                  this.$Message.info('取消成功')
                  this.init()
                }
              })
          },
          onCancel: () => {

          }
        });
      },
      init() {
        this.getDetail()
        this.getDetlist()
      }
    },
    created() {
      this.out_bill_no = this.$route.query.out_bill_no || '';
      if (this.out_bill_no) {
        this.init()
      }

    }
  }
</script>

<style scoped>
  .infn-box {
    padding: 20px;
    border: 1px solid #dcdee2;
    color: #333333;
    margin: 40px 0 20px;
  }

  .infn-box p {
    display: inline-block;
    width: 33%;
    font-size: 14px;
  }

  .infn-box p span {
    display: inline-block;
    /* width: 70px; */
    text-align: right;
  }

  .infn-box .h1 {
    font-weight: bold;
    font-size: 18px;
  }

  .infn-box .bg-yellow {
    background-color: #ffe2b9;
    padding: 10px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .infn-box .bg-yellow p {
    width: 20%;
    font-size: 15px;
    font-weight: bold;
  }

  .infn-box .bg-yellow .ivu-btn {
    font-size: 16px;
  }

  .scan-box {
    display: flex;
    /* align-items: center; */
  }
</style>



// WEBPACK FOOTER //
// src/pages/zhongzhuanfahuo/fahuo/detail.vue